import axios from 'axios';
import { variablesGlobales } from '../configs/variables';


const getInstanceAxios = () => {
  const axiosInstance = axios.create({
    baseURL: variablesGlobales.urlServiceBackend,
    withCredentials: true // Incluye las credenciales (cookies) en la solicitud
  });
  return axiosInstance
}



export default getInstanceAxios;